<template id="cmsForm">
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="/">Home</a></li>
        <li class="breadcrumb-item"><a href="/cms_tag">cms tag</a></li>
        <li class="breadcrumb-item active" aria-current="page">cms tag form</li>
      </ol>
    </nav>
    <div class="row">
      <div class="col-md-10">
        <h3>
          ฟอร์ม CMS Tag (<span v-if="item_id">แก้ไข</span
          ><span v-if="!item_id">เพิ่มใหม่</span>)
        </h3>
      </div>
    </div>
    <form>
      <div class="row">
        <div class="col-md-3">
          <div class="form-group">
            <label for="post_tag_language_id">ภาษา</label>
            <select
              class="form-control"
              id="post_tag_language_id"
              v-model="form.language"
            >
              <option></option>
              <option
                v-for="language in languages"
                v-bind:key="language.id"
                :value="language.code"
              >
                {{ language.name }}, {{ language.localize }}
              </option>
            </select>
            <form-error
              :isError="validateError.language.error"
              :errorMessage="validateError.language.message"
            ></form-error>
          </div>
        </div>

        <div class="col-md-6">
          <div class="form-group">
            <label for="post_tag_name">ชื่อ tag</label>
            <input
              type="text"
              class="form-control"
              id="post_tag_name"
              v-model="form.name"
            />
            <form-error
              :isError="validateError.name.error"
              :errorMessage="validateError.name.message"
            ></form-error>
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group">
            <label for="post_status">ปิดการใช้งาน</label>
            <select
              class="form-control"
              id="post_status"
              v-model="form.disabled"
            >
              <option :value="0">ไม่</option>
              <option :value="1">ใช่</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="post_tag_description">คำอธิบาย tag</label>
            <input
              type="text"
              class="form-control"
              id="post_tag_description"
              v-model="form.description"
            />
            <!-- <form-error :isError="validateError.description.error" :errorMessage="validateError.description.message"></form-error> -->
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="post_tag_header">header tag(header สำหรับ SEO)</label>
            <!-- <input type="text" class="form-control" id="post_tag_header" v-model="form.header">                         -->
            <textarea
              class="form-control"
              id="post_tag_header"
              v-model="form.header"
            ></textarea>
            <!-- <form-error :isError="validateError.description.error" :errorMessage="validateError.description.message"></form-error> -->
          </div>
        </div>
      </div>

      <div class="row m-3">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a
              href="javascript:void(0)"
              onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary"
              >ยกเลิก</a
            >
            <button
              type="button"
              class="btn btn-primary ml-5"
              @click="saveWithGoBack()"
            >
              บันทึก
            </button>
            <button
              type="button"
              v-if="!this.item_id"
              class="btn btn-primary ml-5"
              @click="saveWithMore()"
            >
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>
        </div>
      </div>

      <div class="row border m-0 p-1">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ภาพ Thumbnail</label>
            <img
              v-if="form.thumbnail.url != ''"
              :src="form.thumbnail.url"
              alt=""
              class="img-thumbnail"
            />
          </div>
        </div>
        <div class="col-md-7">
          <!-- <SelectThumbnail v-model="medias" :selected="{}" :medias="medias" @searchMedias="searchMedias"></SelectThumbnail> -->
          <div class="form-group">
            <label for="post_add_thumbnail">ค้นหาภาพ</label>
            <searchbox @searchButtonClick="seachThumbnail"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image
                  :dataImages="thumbnail"
                  :useLabel="true"
                  :w="'80px'"
                  :limit="41"
                  @onselectimage="onSelectThumbnail"
                >
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_thumbnail">&nbsp;</label>
            <a
              id="post_add_thumbnail"
              href="/media/form"
              target="_blank"
              class="btn btn-secondary form-control"
              >เพิ่มภาพใหม่</a
            >
          </div>
        </div>
      </div>

      <div class="row border mt-1 mb-0 mr-0 ml-0 p-1">
        <div class="col-md-3">
          <div class="form-group">
            <label for="">ภาพปก</label>
            <img
              v-if="form.cover.url != ''"
              :src="form.cover.url"
              alt=""
              class="img-thumbnail"
            />
          </div>
        </div>
        <div class="col-md-7">
          <!-- <SelectThumbnail v-model="medias" :selected="{}" :medias="medias" @searchMedias="searchMedias"></SelectThumbnail> -->
          <div class="form-group">
            <label for="post_add_cover">ค้นหาภาพ</label>
            <searchbox @searchButtonClick="seachCover"></searchbox>
            <div class="row">
              <div class="col-md-12 p-1">
                <vue-select-image
                  :dataImages="cover"
                  :useLabel="true"
                  :w="'80px'"
                  :limit="41"
                  @onselectimage="onSelectCover"
                >
                </vue-select-image>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="form-group">
            <label for="post_add_cover">&nbsp;</label>
            <a
              id="post_add_cover"
              href="/media/form"
              target="_blank"
              class="btn btn-secondary form-control"
              >เพิ่มภาพใหม่</a
            >
          </div>
        </div>
      </div>

      <div class="row m-3">
        <div class="col-md-12">
          <div class="form-group float-right">
            <a
              href="javascript:void(0)"
              onclick="javascript:window.history.back(); return false;"
              class="btn btn-secondary"
              >ยกเลิก</a
            >
            <button
              type="button"
              class="btn btn-primary ml-5"
              @click="saveWithGoBack()"
            >
              บันทึก
            </button>
            <button
              type="button"
              v-if="!this.item_id"
              class="btn btn-primary ml-5"
              @click="saveWithMore()"
            >
              บันทึก และ บันทึกเพิ่ม
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import VueSelectImage from "vue-select-image"; //https://npm.runkit.com/vue-select-image สำหรับเลือกภาพ thumbnail
require("vue-select-image/dist/vue-select-image.css");

import searchbox from "../../_layouts/searchbox.vue";
export default {
  props: {
    //item_id ถูกส่งผ่านมาทาง form.blade.php ใน tag component (:item_id="{{empty($id) ? '0' : $id}}")
    //กรณีที่เป็น การ add item_id จะ เท่ากับ 0
    item_id: "",
  },
  components: {
    // VueEditor,
    // SelectTags,
    // SelectThumbnail,
    // htmlEditButton,
    VueSelectImage,
    searchbox,
  },
  data() {
    return {
      form: {
        //ชื่อฟิลด์ต่างๆในฟอร์มที่จะ add หรือ edit ชื่อฟิลด์จะเหมือนกับใน postman
        name: "",
        language: "",
        cover: {},
        thumbnail: { id: null, url: null },
        header: "",
        description: "",
        disabled: 0,
      },
      validateError: {
        // เก็บตัวแปรผลการ submit form ว่ามีฟิลด์ไหน error บ้าง ซึ่งจะ bind กับ ตัวแปรใน <form-error> ให้เลือกเฉพาะฟิลด์ที่ต้อง validate สามารถดูว่าฟิลด์ไหน validate หรือไม่ให้ดูได้ที่ app-backend/app/controller/controller นั้นๆ
        name: { error: false, message: "" },
        language: { error: false, message: "" },
      },
      languages: {
        // เอาไว้เก็บตัวเลือกภาษาใน form select language โดย method fetchLanguages จะไปดึงมาให้จาก laravel
      },
      base_url: "/cms_tag", // base url (เปลี่ยน),
      thumbnail: [],
      cover: [],
    };
  },
  mounted() {},
  beforeMount() {},
  created() {
    this.fetchLanguages();
    if (this.item_id) {
      //ถ้าเป็นการแก้ไข ให้ไปดึงข้อมูลเดิมมาใส่ฟอร์มด้วยฟังก์ชั่น load(this.item_id)
      this.load(this.item_id);
    }
  },
  methods: {
    load(id) {
      axios
        .get(this.base_url + "/" + id)
        .then((response) => {
          console.log(response.data);
          //เอาข้อมูลแต่ละฟิลด์ใส่ฟอร์มหลังจากโหลดมาแล้ว
          this.form.name = response.data.post_tag[0].name;
          // this.form.cover =  response.data.post_tag[0].cover;
          // this.form.thumbnail =  response.data.post_tag[0].thumbnail;
          if (response.data.post_tag[0].cover_data === null) {
            this.form.cover = { id: "", url: "" };
          } else {
            this.form.cover = {
              id: response.data.post_tag[0].cover_data.id,
              url: response.data.post_tag[0].cover_data.url,
            };
          }
          if (response.data.post_tag[0].thumbnail_data === null) {
            this.form.thumbnail = { id: "", url: "" };
          } else {
            this.form.thumbnail = {
              id: response.data.post_tag[0].thumbnail_data.id,
              url: response.data.post_tag[0].thumbnail_data.url,
            };
          }
          this.form.description = response.data.post_tag[0].description;
          this.form.header = response.data.post_tag[0].header;
          this.form.language = response.data.post_tag[0].language.code;
          this.form.disabled = response.data.post_tag[0].disabled;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    seachThumbnail(searchKeword) {
      this.thumbnail = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            console.log(item);
            this.thumbnail.push({
              id: item[1].id,
              src: item[1].url,
              // alt:item[1].original_name
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectThumbnail(data) {
      console.log(data);
      this.form.thumbnail.url = data.src;
      this.form.thumbnail.id = data.id;
    },

    seachCover(searchKeword) {
      this.cover = [];
      this.showLoading = true;
      let url =
        "/media/list?perpage=5&mime_types=jpeg,jpg,gif,png,webp&title=" +
        searchKeword;
      axios
        .get(url)
        .then((response) => {
          let items = response.data.media;
          Object.entries(items).forEach((item, idx) => {
            console.log(item);
            this.cover.push({
              id: item[1].id,
              src: item[1].url,
              // alt:item[1].original_name
            });
          });
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
    onSelectCover(data) {
      console.log(data);
      this.form.cover.url = data.src;
      this.form.cover.id = data.id;
    },

    saveWithGoBack() {
      this.save("");
    },
    saveWithMore() {
      this.save("more");
    },
    save(whatNext) {
      let save_url = "";
      if (this.item_id != "") {
        save_url = this.base_url + "/" + this.item_id + "/update";
      } else {
        save_url = this.base_url;
      }
      let me = this;
      // console.log(this.form);
      axios
        .post(save_url, this.form)
        .then((response) => {
          console.log(response);
          // this.languages = response.data.items;
          this.validateError.name.error = false;
          this.validateError.language.error = false;
          if (whatNext == "more") {
            this.form.name = "";
            this.form.language = "";
            this.form.description = "";
            this.form.header = "";
            this.form.cover = { id: null, url: null };
            this.form.thumbnail = { id: null, url: null };
          } else {
            window.location.href = this.base_url;
          }
        })
        .catch((errors) => {
          if (errors.response.data.message) {
            let errorMessage = errors.response.data.message;
            let fields = Object.keys(this.form);
            fields.forEach(function (item) {
              // console.log(item);
              if (typeof errorMessage[item] != "undefined") {
                me.validateError[item].error = true;
                me.validateError[item].message = errorMessage[item][0];
              }
            });
          } else {
            console.log(errors.response.data._infos.result);
            alert("ไม่สามารถบันทึกได้ " + errors.response.data);
          }
        });
    },
    fetchLanguages(url) {
      url = url || "/fetch/language";
      axios
        .get(url)
        .then((response) => {
          this.languages = response.data.items;
        })
        .catch((errors) => {
          console.log(errors);
        });
    },
  },
};
</script>